import {Component, OnInit, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import * as tablerIcons from '@ng-icons/tabler-icons';
import * as tablerIconsFill from '@ng-icons/tabler-icons/fill';
import {provideIcons} from '@ng-icons/core';
import { LucideAngularModule } from 'lucide-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import {VersionService} from '@core/services/version.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgxSpinnerModule, LucideAngularModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    viewProviders: [provideIcons({...tablerIcons, ...tablerIconsFill})]
})
export class AppComponent implements OnInit {
    private versionService = inject(VersionService);
    title = 'sigo-ng';

    ngOnInit(): void {
        // Log version information to console on app initialization
        this.versionService.logVersion();
    }
}
